import { EditorState, convertToRaw, ContentState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import React, { useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { useSelector } from 'react-redux';
import THEME from '../theme.js';
import Edit from './Icons/Edit.js';
import { Well } from './index.js';
import { Modal, Button } from './index.js';
const RichTextField = (props) => {
    const lang = useSelector((s) => s.lang);
    const contentBlock = htmlToDraft.default(props.value || '');
    const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
    const [updating, setUpdating] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editorState, setEditorState] = useState(EditorState.createWithContent(contentState));
    const update = async () => {
        setUpdating(true);
        const valueToUpdate = draftToHtml(convertToRaw(editorState.getCurrentContent()));
        try {
            await props.onUpdate(valueToUpdate);
        }
        catch (err) {
            alert('Error');
            console.error(err);
        }
        setUpdating(false);
        setEditModalOpen(false);
    };
    return (React.createElement("div", { style: {
            position: 'relative',
        } },
        props.value ? (React.createElement(Well, { style: { ...style, ...props.style }, dangerouslySetInnerHTML: {
                __html: props.value,
            } })) : (React.createElement(Well, { style: { ...style, ...props.style } },
            React.createElement("p", { style: {
                    opacity: '0.7',
                    fontWeight: 900,
                    margin: '0.3em 0',
                } }, lang.creditors.mandatesPlaceholder))),
        props.canUpdate && (React.createElement(Edit, { style: {
                top: '10px',
                right: '10px',
                position: 'absolute',
                cursor: 'pointer',
            }, onClick: () => setEditModalOpen(!editModalOpen) })),
        editModalOpen && (React.createElement(Modal, { onToggle: () => setEditModalOpen(!editModalOpen), header: props.header },
            React.createElement(Editor, { editorState: editorState, onEditorStateChange: setEditorState, stripPastedStyles: true }),
            React.createElement("br", null),
            React.createElement(Button, { loading: updating, onClick: update, block: true }, lang.misc.save)))));
};
const style = {
    fontSize: '.7em',
    padding: `10px ${THEME.GRID_SPACING}px`,
    minHeight: '40px',
    marginBottom: `${THEME.GRID_SPACING}px`,
};
export default RichTextField;
//# sourceMappingURL=RichTextField.js.map